"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _common = require("b2b-components/theme/common");
var _getDisplayName = require("b2b-components/utils/getDisplayName");
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _excluded = ["isAutoplay", "registerVideoStopObject", "video"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var withContainer = function withContainer(Component) {
  var WithContainer = function WithContainer(props) {
    var isAutoplay = props.isAutoplay,
      registerVideoStopObject = props.registerVideoStopObject,
      video = props.video,
      originalProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
    var itemIndex = originalProps.itemIndex;
    var iframeElement = (0, _react.useRef)(null);
    var url = new URL(video.link);
    isAutoplay ? url.searchParams.append('autoplay', '1') : !!url.searchParams.get('autoplay') && url.searchParams["delete"]('autoplay');
    (0, _react.useEffect)(function () {
      registerVideoStopObject === null || registerVideoStopObject === void 0 ? void 0 : registerVideoStopObject({
        onStop: function onStop() {
          if (iframeElement.current) {
            var _iframeElement$curren;
            var src = iframeElement.current.getAttribute('src') || '';
            var _url = new URL(src);
            (_iframeElement$curren = iframeElement.current) === null || _iframeElement$curren === void 0 ? void 0 : _iframeElement$curren.setAttribute('src', _url.href);
          }
        },
        videoIndex: itemIndex || 0
      });
    });
    var injectedProps = {
      iframeElement: iframeElement,
      isVimeo: video.type === _common.VIDEO_TYPE.vimeo,
      url: url
    };
    return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, originalProps, injectedProps));
  };
  WithContainer.displayName = "withContainer(".concat((0, _getDisplayName.getDisplayName)(Component), ")");
  (0, _hoistNonReactStatics["default"])(WithContainer, Component);
  return WithContainer;
};
exports.withContainer = withContainer;